import React from 'react';
import PropTypes from 'prop-types';

const AppCard = ({ id, selectionStyle, onLicenseSelect, appType, headerTitle, contentScaling }) => {
  return (
    <button
      id={id}
      className={`gss-button ${selectionStyle.item} ${
        appType.disabled ? selectionStyle.disabled : ''
      }`}
      onClick={() => onLicenseSelect(appType)}
    >
      <img
        className={[selectionStyle.image, selectionStyle[`image${contentScaling}`]].join(' ')}
        src={appType.image.src}
        alt=""
      />
      <span
        className={[selectionStyle.heading, selectionStyle[`heading${contentScaling}`]].join(' ')}
      >
        {headerTitle}
      </span>
    </button>
  );
};

AppCard.propTypes = {
  id: PropTypes.string.isRequired,
  selectionStyle: PropTypes.object.isRequired,
  appType: PropTypes.object.isRequired,
  headerTitle: PropTypes.string.isRequired,
  onLicenseSelect: PropTypes.func.isRequired,
  contentScaling: PropTypes.number
};

export default AppCard;
